/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1ExceptionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_EXCEPTION_EVENT_ENTITY_NAME = 'ixf.hours.v1.ExceptionEvent';
export const ixfHoursV1ExceptionEventEntity = new schema.Entity<IxfHoursV1ExceptionEvent>(IXF_HOURS_V1_EXCEPTION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1ExceptionEvent) => `${entity.metadata?.eventId}` });

